import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OutlinedInput, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { CadastroEmailNFeValidation } from '../../../interfaces/validation/CadastroEmailNFe/CadastroEmailNFeValidation';
import { atualizarEmailNFE, getEmailNFE } from '../../../services/BeneficiarioService';
import './styles.css';
import { sxButtonLogin, sxInputEmail, sxLabel, sxValidationMessage } from "./sxProps";
import { useNavigate } from "react-router-dom";
import { getPermissaoCadastroBoleto } from "../../../services/PermissoesService";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../components/Accessibility/PageTitle";

type Props = {}

const CadastroEmailNFe = (props: Props) => {
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [permission, setPermission] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('Esta funcionalidade não está disponível para o seu cartão.');

  const accessibility = useAccessibility();

  const navigate = useNavigate();

  useEffect(() => {
    if (!email)
      getEmail();

    getPermissao();
  }, [])

  const getEmail = async () => {
    setLoading(true);
    var response = await getEmailNFE();
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao buscar e-mail cadastrado.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    }
    setEmail(response.data.valor);
    setLoading(false);
  };

  const registerEmail = async (email: string) => {
    setLoading(true);
    var response = await atualizarEmailNFE(email);
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao atualizar e-mail.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    } else {
      setmodalFeedback({
        icon: 'success',
        title: 'E-mail atualizado',
        subTitle: 'O e-mail para recebimento da NFe foi atualizado e salvo com sucesso!',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
    }
    setEmail(email);
    setLoading(false);
    formik.resetForm();
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      emailConfirmation: ''
    },
    validationSchema: CadastroEmailNFeValidation,
    onSubmit: (values) => {
      registerEmail(values.email);
    },
    validateOnChange: false
  });

  const getPermissao = async () => {
    setLoading(true)
    var response = await getPermissaoCadastroBoleto();

    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: response?.data.mensagem ? response?.data.mensagem : 'Erro ao buscar permissão.',
        textButton: 'Fechar',
        action: () => {
          setmodalFeedback(null)
          navigate('/home')
        }
      });
      setLoading(false);
      return;
    }

    if (!response.data.isPermissao) {
      setPermission(false)

      const listaInfo = response?.data?.listaInfo;
      if (listaInfo.length) {
          const msg = listaInfo.map((info: { mensagem: string; }) => info.mensagem)[0];
          if (msg) setErrorMessage(msg);
      }
    }
    setLoading(false)
  }

  return (
    <>
      <div className='email-nfe-container'>
        <PageTitle text="E-mail para Nota Fiscal (NFe)" />
        <Typography style={accessibility.textStyleAccessibility} className="email-nfe-subtitle">Confira o e-mail cadastrado para recebimento de Nota Fiscal Eletrônica (NFe) referente ao pagamento da sua mensalidade.</Typography>
        {!loading && !permission ?
          <div>
            <Typography style={accessibility.textStyleAccessibility}>{errorMessage}</Typography>
          </div>
          :
          <>
            {email &&
              <div className='container-email-cadastrado'>
                <strong className="email-atual" style={accessibility.textStyleAccessibility}>E-mail Cadastrado:</strong>
                <span style={accessibility.textStyleAccessibility} className="email-nfe-subtitle-cadastrado">{email}</span>
              </div>
            }
            <form onSubmit={formik.handleSubmit} className="email-nfe-form" noValidate>
              <strong style={accessibility.textStyleAccessibility} className="email-atual">Alterar e-mail:</strong>
              <div className='width-100 container-input-email'>
                <div className='width-100 margin-bottom-20'>
                  <Typography component="h2" style={accessibility.textStyleAccessibility} sx={sxLabel}>Novo e-mail</Typography>
                  <label htmlFor="email-input" aria-label="Novo email" />
                  <OutlinedInput
                    fullWidth
                    style={accessibility.textStyleAccessibility}
                    sx={sxInputEmail}
                    type={'email'}
                    value={formik?.values?.email}
                    placeholder='email@email.com'
                    onChange={formik.handleChange}
                    name='email'
                    id="email-input"
                    aria-describedby={formik.errors.email ? "errEmail" : undefined}
                    error={!!formik.errors.email || !!formik.errors.emailConfirmation}
                    maxRows={1}
                    inputProps={{ maxLength: 100 }}

                  />
                  {formik.errors.email &&
                    <div className='container-validation-message'>
                      <Typography style={accessibility.textStyleAccessibility} id='errEmail' sx={sxValidationMessage}>{formik.errors.email}</Typography>
                    </div>
                  }
                </div>
                <div className='width-100 margin-bottom-20'>
                  <Typography component="h2" style={accessibility.textStyleAccessibility} sx={sxLabel}>Confirmar e-mail</Typography>
                  <label htmlFor="email-confirmar-input" aria-label="Confirmar email" />
                  <OutlinedInput
                    fullWidth
                    type={'email'}
                    style={accessibility.textStyleAccessibility}
                    sx={sxInputEmail}
                    value={formik?.values?.emailConfirmation}
                    placeholder='email@email.com'
                    onChange={formik.handleChange}
                    name='emailConfirmation'
                    id='email-confirmar-input'
                    aria-describedby={formik.errors.emailConfirmation ? "errEmailConfirmation" : undefined}
                    error={!!formik.errors.email || !!formik.errors.emailConfirmation}
                    maxRows={1}
                    inputProps={{ maxLength: 100 }}
                  />
                  {formik.errors.emailConfirmation &&
                    <div className='container-validation-message'>
                      <Typography id='errEmailConfirmation' sx={sxValidationMessage}  >{formik.errors.emailConfirmation}</Typography>
                    </div>
                  }
                </div>
              </div>
              <Button style={accessibility.buttonStyleAccessibility} disabled={!formik?.values?.email || !formik?.values?.emailConfirmation} type='submit' variant='contained' sx={sxButtonLogin}>
                <Typography style={accessibility.buttonTextStyleAccessibility}>Salvar</Typography>
              </Button>
            </form>
          </>
        }
      </div>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        handleButtonModal={modalFeedback?.action}
      />
    </>
  )
}

export default CadastroEmailNFe